// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-loader {
  min-width: 500px;
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Loaders/ToolTipContentLoader.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;AACF","sourcesContent":[".tooltip-loader {\n  min-width: 500px;\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
